// SectionTitle.tsx
import React from 'react';
import { styled } from 'leva/plugin';

const Title = styled('p', {
  marginLeft: '10px',
  color: '#fefefe',
  fontSize: 'medium',
});

interface SectionTitleProps {
  title: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
  return <Title>{title}</Title>;
};
